import {
	Avatar,
	Box,
	Card,
	Flex,
	Group,
	Menu,
	ScrollArea,
	Skeleton,
	Text,
	UnstyledButton,
} from '@mantine/core'
import { modals } from '@mantine/modals'
import { IconCirclePlus, IconLogout } from '@tabler/icons-react'
import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import {
	getAllBusinessesAction,
	getBusinessByIdAction,
	switchBusinessAction,
} from '../../store/business/businessesActions.ts'
import { useAppDispatch, useAppSelector } from '../../store/store.ts'
import { clearToken, getUser } from '../../utils/storage.ts'
import classes from './UserButton.module.css'

type UserButtonProps = {
	toggle: () => void
	isSeller: boolean
}

export function UserButton({ toggle }: UserButtonProps) {
	const user = getUser()
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const { allBusiness, loaders, singleBusiness } = useAppSelector(
		(state) => state.business
	)
	const { authUser } = useAppSelector((state) => state.account)
	const primaryBusiness = useMemo(
		() => authUser?.user?.primaryBusiness?._id,
		[authUser?.user?.primaryBusiness?._id]
	)
	const currentBusinessId = authUser?.user?.primaryBusiness?._id

	useEffect(() => {
		dispatch(getAllBusinessesAction())
		if (!primaryBusiness) return
		dispatch(getBusinessByIdAction(primaryBusiness))
	}, [dispatch, primaryBusiness])

	return (
		<UnstyledButton
			variant='filled'
			className={classes.user}
			onClick={() => {
				// if (isSeller) {
				//     navigate("/seller/seller-profile")
				// } else {
				//     navigate("my-account")
				// }
				// toggle()
			}}
			style={{
				border: '1px solid #E5E7EB',
				borderRadius: '20px',
			}}
		>
			{' '}
			<Menu position={'top'} width={300}>
				<Menu.Target>
					<Flex align='center' gap='sm'>
						{loaders.gettingAllBusiness ? (
							<Group w={'100%'}>
								<Skeleton height={50} circle />
								<div style={{ flex: 1 }}>
									<Skeleton height={50} w={'100%'} radius='xl' />
								</div>
							</Group>
						) : (
							<Group>
								<Avatar src={singleBusiness?.businessInfo?.image} radius='xl' />

								<div style={{ flex: 1 }}>
									<Text size='sm' fw={500}>
										{singleBusiness?.businessInfo?.title ||
											'No Business Selected'}
									</Text>

									<Box w='175px'>
										<Text truncate='end' c='dimmed' size='xs'>
											{singleBusiness?.businessInfo?.email}
										</Text>
									</Box>
								</div>
							</Group>
						)}
					</Flex>
				</Menu.Target>
				<Menu.Dropdown
					p='xs'
					style={{ borderRadius: '15px' }}
					className='bg-linear-to-r/srgb from-[#3A4DE926] to-[#FF816426]'
				>
					<Card p={0} radius='lg'>
						<Menu.Item>
							<Group>
								<Avatar src={user?.profilePic} radius='xl' />
								<div style={{ flex: 1 }}>
									<Text size='sm' fw={500}>
										{user?.firstName}
									</Text>

									<Box w='175px'>
										<Text truncate='end' c='dimmed' size='xs'>
											{user?.email}
										</Text>
									</Box>
								</div>

								{/* <IconChevronRight
									style={{ width: rem(14), height: rem(14) }}
									stroke={1.5}
								/> */}
							</Group>
						</Menu.Item>
						<Menu.Divider />
						<ScrollArea h={250}>
							{allBusiness?.businesses?.map((item, index) => (
								<Menu.Item
									key={index}
									onClick={async () => {
										await dispatch(switchBusinessAction(item?._id))
										dispatch(getBusinessByIdAction(item?._id))

										toggle()
									}}
									bg={item._id === currentBusinessId ? 'lime' : 'transparent'}
									c={item._id === currentBusinessId ? 'white' : 'black'}
									style={{
										borderRadius: '10px',
									}}
								>
									<Flex align='center' gap='sm'>
										<Avatar src={item?.image} />
										<Text>{item?.title}</Text>
									</Flex>
								</Menu.Item>
							))}
						</ScrollArea>
						<Menu.Divider />
						<Menu.Item onClick={() => navigate('/create-business')}>
							<Flex align='center' gap='sm'>
								<Avatar>
									<IconCirclePlus />
								</Avatar>
								<Text>Create business</Text>
							</Flex>
						</Menu.Item>
						<Menu.Divider />
						<Menu.Item
							onClick={() => {
								modals.openConfirmModal({
									title: 'Logout your profile',
									centered: true,
									children: (
										<Text size='sm'>
											Are you sure you want to Logout your profile?
										</Text>
									),
									labels: { confirm: 'Logout', cancel: 'cancel' },
									confirmProps: { color: 'red' },
									onCancel: () => console.log('Cancel'),
									onConfirm: () => {
										clearToken()
										navigate('/')
									},
								})
							}}
						>
							<Flex align='center' gap='sm'>
								<Avatar>
									<IconLogout />
								</Avatar>
								<Text>Logout</Text>
							</Flex>
						</Menu.Item>
					</Card>
				</Menu.Dropdown>
			</Menu>
		</UnstyledButton>
	)
}
